import { Select, Spin } from "antd";
import { debounce } from "lodash";
import React, { useMemo, useRef, useState } from "react";
import ICustomRemoteSelectInput from "components/CustomRemoteSelectInput/ICustomRemoteSelectInputProps";
import "./CustomRemoteSelectInput.css";
import { IOption } from "core/interfaces/data/IOption";
import { DefaultOptionType } from "antd/lib/select";
import _ from "lodash";

const CustomRemoteSelectInput: React.FC<ICustomRemoteSelectInput> = ({
	fetchOptions,
	debounceTimeout = 800,
	maxTagAllowed,
	onValueChanged,
	options,
	setOptions,
	selectValue,
	setSelectValue,
	...props
}) => {
	const [fetching, setFetching] = useState(false);

	const fetchRef = useRef(0);
	const selectRef: any = useRef(null);

	const debounceFetcher = useMemo(() => {
		const loadOptions = (value: string) => {
			fetchRef.current += 1;
			const fetchId = fetchRef.current;
			setOptions([]);
			setFetching(true);
			fetchOptions(value).then((newOptions: { label: string; value: string }[] | IOption[] | undefined) => {
				if (fetchId !== fetchRef.current) {
					// for fetch callback order
					return;
				}
				if (newOptions) {
					var options = _.flatMap(newOptions, (val) => {
						let res: DefaultOptionType;
						if (val.hasOwnProperty("Key")) {
							res = { label: (val as IOption).label, value: (val as IOption).value };
						} else {
							res = val as { label: string; value: string };
						}

						return res;
					});
					setOptions(options);
				}
				setFetching(false);
			});
		};

		return debounce(loadOptions, debounceTimeout);
	}, [debounceTimeout, setOptions, fetchOptions]);

	const getProps = () => {
		var res = props;
		res.className = props.className ?? "";
		res.dropdownClassName = props.dropdownClassName ?? "";
		return res;
	};

	return (
		<div className="customRemoteSelectInput">
			<Select
				{...getProps()}
				labelInValue
				showSearch
				ref={selectRef}
				value={selectValue}
				filterOption={false}
				onSearch={debounceFetcher}
				notFoundContent={fetching ? <Spin size="small" /> : null}
				options={options}
				onChange={(newValue: any) => {
					setSelectValue(newValue);
					if (onValueChanged) onValueChanged(newValue?.value);
				}}
			/>
		</div>
	);
}; // Usage of DebounceSelect

export default CustomRemoteSelectInput;
